module.exports = __webpack_public_path__ + "static/media/INZ1263.a4722aa8.pdf";